import { Button } from '@zyxantech/tux'
import { ShieldX } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { EmptyState } from '@/components/shared/EmptyState'
import { ROUTES } from '@/constants/routes'

/** 403 — authenticated but the role lacks access to this area. */
export function ForbiddenPage() {
  const navigate = useNavigate()
  return (
    <EmptyState
      icon={<ShieldX size={32} />}
      title="Access denied"
      message="Your role doesn't have permission to view this area. Contact an administrator if you believe this is a mistake."
      action={<Button onClick={() => navigate(ROUTES.OVERVIEW)}>Back to overview</Button>}
    />
  )
}
